import { __rest, __assign } from '../_virtual/_tslib.js';
import React, { useState } from 'react';
import { StyledButton, LoadingSpinnerWrapper } from './styles/index.js';
export { default as KakaoButton } from './SocialLoginButton/Kakao.js';
export { default as AppleButton } from './SocialLoginButton/Apple.js';
import LoadingSpinnerSvg from '../common/LoadingSpinnerSvg/LoadingSpinnerSvg.js';

function Button(_a, ref) {
  var _b = _a.styleType,
      styleType = _b === void 0 ? 'secondary' : _b,
      _c = _a.size,
      size = _c === void 0 ? 'medium' : _c,
      href = _a.href,
      _d = _a.fullwidth,
      fullwidth = _d === void 0 ? 'none' : _d,
      loading = _a.loading,
      disabled = _a.disabled,
      children = _a.children,
      target = _a.target,
      props = __rest(_a, ["styleType", "size", "href", "fullwidth", "loading", "disabled", "children", "target"]);

  var _e = useState(null),
      loadingSpinnerWrapperElement = _e[0],
      setLoadingSpinnerWrapperElement = _e[1];

  if (typeof href === 'string' && href) {
    return React.createElement(StyledButton, __assign({
      as: "a",
      href: href,
      styleType: styleType,
      size: size,
      fullwidth: size === 'x-small' ? 'none' : fullwidth,
      ref: ref,
      disabled: disabled || loading,
      target: target,
      rel: target === '_blank' ? 'noopener noreferrer' : undefined
    }, props), (styleType === 'primary' || styleType === 'danger' || styleType === 'outline') && loading && React.createElement(LoadingSpinnerWrapper, {
      ref: setLoadingSpinnerWrapperElement,
      buttonSize: size,
      buttonStyleType: styleType
    }, React.createElement(LoadingSpinnerSvg, {
      container: loadingSpinnerWrapperElement
    })), (size !== 'x-small' && size !== 'small' || !loading) && children);
  }

  return React.createElement(StyledButton, __assign({
    styleType: styleType,
    size: size,
    fullwidth: size === 'x-small' ? 'none' : fullwidth,
    ref: ref,
    disabled: disabled || loading
  }, props), (styleType === 'primary' || styleType === 'danger' || styleType === 'outline') && loading && React.createElement(LoadingSpinnerWrapper, {
    ref: setLoadingSpinnerWrapperElement,
    buttonSize: size,
    buttonStyleType: styleType
  }, React.createElement(LoadingSpinnerSvg, {
    container: loadingSpinnerWrapperElement
  })), (size !== 'x-small' && size !== 'small' || !loading) && children);
}

var Button$1 = React.forwardRef(Button);
export { Button$1 as default };